{
  "_vgBinding": "vg-binding: P4.4.2.D-12 P4.4.2.D-13 P4.4.2.D-14 P4.4.2.D-15 INTERFACE-STANDARDS:error-shape — complete vendorAllocations namespace (stats/configs/proposals tabs + dialogs + chip + 9 domain error codes user_message) owned by task-12; Wave-4 tabs consume t() only [task-12]",
  "page": {
    "title": "Vendor Allocations",
    "subtitle": "Statistiques d'allocation par vendor, configuration des poids de split et approbation des changements.",
    "newSplit": "+ Nouveau split"
  },
  "nav": {
    "allocations": "Allocations"
  },
  "tabs": {
    "stats": "Stats",
    "configs": "Configs",
    "proposals": "Proposals"
  },
  "common": {
    "cancel": "Annuler",
    "close": "Fermer",
    "save": "Enregistrer",
    "retry": "Réessayer",
    "loading": "Chargement…",
    "confirm": "Confirmer",
    "na": "N/A"
  },
  "filters": {
    "searchLabel": "Rechercher",
    "searchPlaceholder": "SKU, blueprint, location…",
    "blueprintLabel": "Blueprint",
    "allBlueprints": "Tous les blueprints",
    "vendorLabel": "Vendor",
    "allVendors": "Tous les vendors",
    "statusLabel": "Statut",
    "allStatuses": "Tous les statuts",
    "dateRangeLabel": "Plage de dates"
  },
  "stats": {
    "table": {
      "vendor": "Vendor",
      "variants": "Variantes",
      "quantity": "Quantité",
      "cost": "Coût",
      "assignments": "Affectations"
    },
    "footer": {
      "totals": "Totaux",
      "missingCostCaveat": "{{count}} affectations sans coût figé"
    },
    "empty": {
      "title": "Aucune activité d'allocation",
      "description": "Aucune affectation de vendor n'a été créée dans cette plage de dates."
    },
    "drilldown": {
      "title": "Détail par variante",
      "variant": "Variante",
      "sku": "SKU",
      "location": "Location",
      "quantity": "Quantité",
      "cost": "Coût",
      "assignments": "Affectations",
      "reconcile": "Total réconcilié",
      "locationNA": "Location N/A",
      "empty": "Aucune activité de variante pour ce vendor dans la plage."
    },
    "assignmentStatus": {
      "rejected": "Rejeté",
      "superseded": "Remplacé",
      "completed": "Terminé"
    }
  },
  "configs": {
    "table": {
      "blueprint": "Blueprint",
      "variantSku": "Variante (SKU)",
      "location": "Location",
      "vendors": "Vendors",
      "actions": "Actions"
    },
    "actions": {
      "disable": "Désactiver",
      "propose": "Proposer un changement",
      "openBlueprint": "Ouvrir le blueprint"
    },
    "empty": {
      "title": "Aucune configuration de split",
      "description": "Aucune variante de blueprint n'a encore de split de vendor."
    },
    "pagination": {
      "showing": "Affichage de {{shown}} / {{total}} configurations",
      "prev": "‹ Préc.",
      "next": "Suiv. ›"
    },
    "disable": {
      "title": "Désactiver le vendor du split",
      "lastVendorWarning": "C'est le dernier vendor activé — les nouvelles commandes seront routées par top-score au lieu du split configuré.",
      "reasonLabel": "Raison",
      "reasonRequired": "(obligatoire)",
      "reasonPlaceholder": "ex. : Vendor en pause sur les mugs — rupture de supports cette semaine…",
      "reasonHint": "La raison est enregistrée dans l'historique d'allocation pour une réconciliation ultérieure.",
      "confirm": "Confirmer la désactivation",
      "cancel": "Annuler",
      "toast": {
        "success": "Vendor désactivé pour ce split."
      }
    },
    "propose": {
      "title": "Proposer un changement",
      "reasonLabel": "Raison",
      "reasonPlaceholder": "Expliquez la réactivation ou le changement de poids…",
      "weightLabel": "Poids (%)",
      "submit": "Soumettre la proposition",
      "toast": {
        "success": "Proposition soumise pour approbation."
      },
      "noChanges": "Aucune modification à proposer.",
      "disableViaDirect": "Pour désactiver, utilisez le ✕ sur la puce du fournisseur (audité). Les propositions ne peuvent que réactiver."
    }
  },
  "proposals": {
    "pending": {
      "title": "File d'attente"
    },
    "history": {
      "title": "Historique"
    },
    "table": {
      "blueprint": "Blueprint",
      "variant": "Variante",
      "location": "Location",
      "changes": "Changements",
      "reason": "Raison",
      "proposedBy": "Proposé par",
      "proposedAt": "Proposé le",
      "status": "Statut",
      "decidedBy": "Décidé par",
      "decidedAt": "Décidé le",
      "decisionReason": "Raison de la décision",
      "actions": "Actions"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "change": {
      "enable": "Activer",
      "disable": "Désactiver",
      "weightDelta": "{{from}}% → {{to}}%",
      "weightSet": "{{to}}%"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter"
    },
    "selfApprovalDisabled": "Vous ne pouvez pas approuver votre propre proposition.",
    "empty": {
      "pending": "Aucune proposition en attente.",
      "history": "Aucune proposition traitée pour l'instant."
    },
    "badge": {
      "pendingAria": "{{count}} propositions en attente"
    },
    "reject": {
      "title": "Rejeter la proposition",
      "reasonLabel": "Raison",
      "reasonRequired": "(obligatoire)",
      "reasonPlaceholder": "Expliquez pourquoi cette proposition est rejetée…",
      "confirm": "Confirmer le rejet",
      "cancel": "Annuler",
      "toast": {
        "success": "Proposition rejetée."
      }
    },
    "approve": {
      "confirmTitle": "Approuver la proposition",
      "toast": {
        "success": "Proposition approuvée et appliquée."
      }
    }
  },
  "chip": {
    "enabled": "Enabled",
    "disabled": "Disabled",
    "weightAria": "Poids {{pct}}%",
    "inactive": "suspendu",
    "missing": "aucun profil"
  },
  "errors": {
    "ALLOC_SUM_INVALID": "La somme des poids des vendors doit être égale à 100 %.",
    "ALLOC_RANGE_TOO_WIDE": "La plage de dates doit être de 365 jours ou moins.",
    "ALLOC_RANGE_INVALID": "La date de début doit précéder la date de fin.",
    "ALLOC_ENTRY_NOT_FOUND": "Entrée d'allocation introuvable.",
    "ALLOC_ALREADY_DISABLED": "Ce vendor est déjà désactivé pour ce split.",
    "ALLOC_PATCH_FORBIDDEN": "La modification des poids d'un split existant nécessite une proposition.",
    "PROPOSAL_SELF_APPROVAL": "Vous ne pouvez pas approuver votre propre proposition.",
    "PROPOSAL_STALE": "Le blueprint a changé depuis cette proposition — veuillez la re-soumettre.",
    "PROPOSAL_PENDING_EXISTS": "Une proposition en attente existe déjà pour ce split.",
    "PROPOSAL_ALREADY_DECIDED": "Cette proposition a déjà été traitée.",
    "PROPOSAL_DISABLE_FORBIDDEN": "Pour désactiver un fournisseur, utilisez l'action de désactivation afin que le changement soit audité — cela ne peut pas être proposé.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "Cette répartition confie du travail à un vendeur que la liaison de site ne couvre pas. Rien n'a été enregistré — corrigez la répartition ou élargissez la liaison.",
    "locationBinding": {
      "list": "Non couvert par la liaison : {{list}}.",
      "more": "Et {{count}} de plus."
    },
    "VALIDATION_FAILED": "Certains champs sont invalides. Veuillez vérifier et réessayer.",
    "UNAUTHENTICATED": "Veuillez vous connecter pour continuer.",
    "FORBIDDEN": "Vous n'avez pas la permission d'effectuer cette action.",
    "PROPOSAL_NOT_FOUND": "Proposition introuvable.",
    "NETWORK_ERROR": "Erreur réseau — vérifiez votre connexion.",
    "GENERIC": "Une erreur s'est produite. Veuillez réessayer.",
    "AUTH_CSRF_MISSING": "Le jeton de sécurité de session est manquant. Veuillez actualiser la page et réessayer.",
    "AUTH_CSRF_MISMATCH": "Le jeton de sécurité de session a expiré. Veuillez actualiser la page et réessayer.",
    "TIMEOUT": "La requête a expiré. Veuillez réessayer.",
    "INTERNAL_ERROR": "Une erreur interne s'est produite. Veuillez réessayer."
  }
}
